<form [formGroup]="formGroup">
  <fieldset>
    <legend class="section-sub-label">Personal Details</legend>
    <div fxLayout="row" fxLayout.xs="column">
      <div class="ssnDiv labelDiv" fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="ssn-label">Social Security Number
        </mat-label>
        <div class="form-input" >
          <mat-form-field appearance="outline" >
            <input [type]="hideSsn ? 'password' : 'text'" autocomplete="off"
                   formControlName="ssnNumber"
                   id="ssnNumber"
                   mask="000-00-0000"
                   [hiddenInput]="maskSsn"
                   matInput
                   (keypress)="validateSSN($event)"
                   (blur)="hideEye()"
                   required>
            <mat-error class="accessibilityError">{{this.getFieldError("ssnNumber")}} field invalid</mat-error>
            <button [attr.aria-label]="'Hide social security number'" [attr.aria-pressed]="!hideSsn" mat-icon-button
                    matSuffix>
              <mat-icon (click)="hideSsn = !hideSsn"  class="click-icon"
                        id="ssnVisibility">{{hideSsn ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="firstName-label">First Name
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input autocomplete="given-name" formControlName="firstName" id="firstName" matInput
                   placeholder="First Name" required>
            <mat-error class="accessibilityError">{{this.getFieldError("firstName")}} field invalid</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="middleName-label">Middle Name (optional)
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input autocomplete="given-name" formControlName="middleName" id="middleName" matInput
                   placeholder="Middle Name">
            <mat-error class="accessibilityError">{{this.getFieldError("middleName")}} field invalid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="lastName-label">Last Name
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input autocomplete="family-name" formControlName="lastName" id="lastName" matInput placeholder="Last Name"
                   required>
            <mat-error class="accessibilityError">{{this.getFieldError("lastName")}} field invalid</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="suffix-label">Suffix (optional)
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Suffix" formControlName="suffix" autocomplete="family-name">
              <mat-option value="">--Select--</mat-option>
              <mat-option value="Sr">Sr</mat-option>
              <mat-option value="Jr">Jr</mat-option>
              <mat-option value="II">II</mat-option>
              <mat-option value="III">III</mat-option>
              <mat-option value="IV">IV</mat-option>
              <mat-option value="V">V</mat-option>
              <mat-option value="MD">MD</mat-option>
              <mat-option value="Esq">Esq</mat-option>
            </mat-select>
            <mat-error class="accessibilityError">{{this.getFieldError("suffix")}} field invalid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column">
        <mat-label id="preferredName-label">Preferred Name
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input autocomplete="given-name" formControlName="preferredName" id="preferredName"
                   matInput placeholder="Preferred Name">
            <!--mat-error class="accessibilityError">{{this.getFieldError("preferredName")}} field invalid</mat-error-->
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="birthDate-label">Date of Birth
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input (keyup)="onDateKeyUp($event)" [matDatepicker]="dp" [max]="maxDate" [min]="minDate" autocomplete="bday"
                   formControlName="birthDate"
                   id="birthDate" matInput placeholder="Birth Date" required>
            <mat-error class="accessibilityError">{{this.getFieldError("birthDate")}} field invalid</mat-error>
            <mat-hint style="display: none;">date format: mm/dd/yyyy</mat-hint>
            <mat-datepicker #dp></mat-datepicker>
            <mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="email-label" *ngIf="!isEmployeeProduct">Email</mat-label>
        <mat-label id="email-label" *ngIf="isEmployeeProduct">Personal Email</mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <input autocomplete="email" formControlName="emailAddress" id="email" matInput placeholder="Email" type="email">
            <mat-error class="accessibilityError">{{this.getFieldError("emailAddress")}} field invalid</mat-error>
            <mat-error *ngIf="formGroup.get('email')?.hasError('required')">Email is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="phoneDiv labelDiv" fxLayout="column" fxLayoutAlign="end start">
        <mat-label id="phoneNumber-label">Phone Number
        </mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
                  <input matInput mask="000-000-0000" [showMaskTyped]="true" id="phone" placeholder="Phone Number"
                  formControlName="phoneNumber" type="tel" autocomplete="tel">
            <mat-error class="accessibilityError">{{this.getFieldError("phoneNumber")}} field invalid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="!isPrimary" fxLayout="row" fxLayout.xs="column">
      <div fxFlex>
        <div>Use same address as primary applicant?</div>
      </div>
      <div fxFlex>
        <mat-radio-group (change)="onUsePrimaryAddress($event)">
          <mat-radio-button [checked]="(usePrimaryAddress)" [value]="true">Yes</mat-radio-button>
          <mat-radio-button [checked]="(!usePrimaryAddress)" [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <ng-container *ngIf="isPrimary || !usePrimaryAddress">
      <div fxLayout="row" fxLayoutGap="20px">
        <div class="address1Div labelDiv" fxLayout="column" fxLayoutAlign="end start">
          <mat-label id="addressLine1-label">Address Line 1</mat-label>
          <mat-form-field appearance="outline">
            <input (onAddressChange)="facadeService.fillInAddress($event, formGroup, 'pwa')" [options]="options" aria-autocomplete="list" aria-controls="pac-container"
                   aria-haspopup="listbox" autocomplete="false"
                   formControlName="addressLine1" matInput ngx-google-places-autocomplete placeholder="Address Line 1"
                   required>
            <mat-error class="accessibilityError">{{this.getFieldError("addressLine1")}} field invalid</mat-error>
            <mat-hint style="display:none;">Begin typing an address, arrow down to see results, use arrow keys to
              navigate, Enter to select
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="address1Div labelDiv" fxLayout="column" fxLayoutAlign="end start">
          <mat-label id="addressLine2-label">Address Line 2 (optional)</mat-label>
          <mat-form-field appearance="outline">
            <input autocomplete="false" formControlName="addressLine2" id="addressLine2" matInput
                   placeholder="Address Line 2">
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxLayout="column" fxLayoutAlign="end start">
          <mat-label id="city-label">City</mat-label>
          <mat-form-field appearance="outline">
            <input autocomplete="false" formControlName="city" id="city" matInput placeholder="City" required
                   type="text">
            <mat-error class="accessibilityError">{{this.getFieldError("city")}} field invalid</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="end start">
          <mat-label id="state-label">State</mat-label>
          <mat-form-field appearance="outline">
            <mat-select [aria-label]="isPrimary ? 'Primary applicant state' : 'Co-applicant state'" [compareWith]="compareValueWithSelection" formControlName="state" id="state" matInput
                        required>
              <mat-option [value]="0">--Select--</mat-option>
              <mat-option *ngFor="let curState of stateList" [attr.data-stateAbbr]="curState.stateAbbr"
                          [value]="curState.id">{{curState.stateName}}</mat-option>
            </mat-select>
            <mat-error class="accessibilityError">{{this.getFieldError("state")}} field invalid</mat-error>
            <mat-hint style="display: none;">Enter to expand</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxLayout="column" fxLayoutAlign="end start">
          <mat-label id="zip-label">ZIP</mat-label>
          <mat-form-field appearance="outline">
            <input autocomplete="false" formControlName="zipCode" id="zip" matInput placeholder="Zip" required>
            <mat-error class="accessibilityError">{{this.getFieldError("zipCode")}} field invalid</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="center center">
          <a mat-flat-button (click)="onValidateClicked()">Validate Address with USPS</a>
        </div>
      </div>
    </ng-container>
  </fieldset>
</form>
<br>
